import { render, staticRenderFns } from "./InsuranceModal.vue?vue&type=template&id=1fc8dba0&"
import script from "./InsuranceModal.vue?vue&type=script&lang=js&"
export * from "./InsuranceModal.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports